<template>
  <td>
    <router-link v-if="useLink" class="link_modal" :to="linkUrl">
      {{content}}
    </router-link>
    <button v-else type="button" class="link_modal" @click="$emit('popupClick')">
      {{content}}
    </button>
  </td>
</template>

<script>
import newsMixin from "$views/News/_mixin";

export default {
  props: {
    content: String,
    useLink: Boolean,
    linkUrl: String
  }
};
</script>

<style>
</style>